import { render, staticRenderFns } from "./FooterSimple.vue?vue&type=template&id=7b70134f&scoped=true"
import script from "./FooterSimple.vue?vue&type=script&lang=js"
export * from "./FooterSimple.vue?vue&type=script&lang=js"
import style0 from "./FooterSimple.vue?vue&type=style&index=0&id=7b70134f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b70134f",
  null
  
)

export default component.exports